export const HeaderNotices = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: `Bearer ${process.env.REACT_APP_API_BEARER}`,
  }